module.exports = __webpack_public_path__ + "static/media/home_fmps.5a041ac1.mp4";